/* eslint-disable react/react-in-jsx-scope */
import { message } from 'antd';
import { getTableData, searchList, sort, roleUserSort } from '../../services/department/deptRole';
import { removeRole } from '../../services/roleManage/inedx';
import { setNanoId } from '@/utils/nanoId';
import { setSpinProps } from '@/utils/utils';

const initState = () => {
  return {
    currentDeptId: '', // 当前部门的id
    columns: [
      {
        title: '姓名',
        dataIndex: 'deptName',
      },
      {
        title: '岗位',
        dataIndex: 'personCount',
      },
      {
        title: '电话',
        dataIndex: 'subDeptCount',
      },
      // {
      //   title: '操作',
      //   dataIndex: '',
      //   render: () => (
      //     <span>
      //       <a href="javascript:;">编辑</a>
      //       <a href="javascript:;">删除</a>
      //     </span>
      //   ),
      // },
    ],
    /**
     * userId: string 用户id
     * userName: string 用户名称
     * roleSign: string 角色id
     * roleName: string角色名
     * phone: string 电话
     */
    data: [],
    tableId: setNanoId({ str: 'tableKey' }),
    currentPage: 1, // 当前页码
    // 调整顺序开关
    isDragPattern: false,
    selectedRowKeys: [],
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'countyDeptRole',

  state: initState(),

  effects: {
    // 获取下级部门列表数据
    *fetchList({ searchParams }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { headers, rows } = yield call(getTableData, searchParams);

        yield put({
          type: 'save',
          payload: {
            data: rows,
            columns: headers,
            tableId: setNanoId({ str: 'tableKey' }),
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 获取下级部门列表数据
    *fetchSearch({ searchParams }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { rows } = yield call(searchList, searchParams);

        yield put({
          type: 'save',
          payload: {
            data: rows,
            tableId: setNanoId({ str: 'tableKey' }),
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 移除部门岗位
    *removeMember({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '移除中...' });

        yield call(removeRole, params);

        yield put({
          type: 'save',
          payload: {
            selectedRowKeys: [],
            tableId: setNanoId({ str: 'tableKey' }),
            spinProps: {
              spinning: false,
            },
          },
        });

        message.success('移除岗位成功');
        if (callback) {
          setTimeout(() => {
            callback();
          }, 300);
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 排序
    *fetchSort({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '保存中...' });

        yield call(sort, params);

        yield setSpinProps({ put });

        if (callback) {
          callback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 排序
    *fetchRoleUserSort({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '保存中...' });

        yield call(roleUserSort, params);

        yield setSpinProps({ put });

        if (callback) {
          callback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
